export default __webpack_public_path__ + "static/banner-84df44b76b17b05463f3d02594f1b4d4.webp";